import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Select,
  MenuItem,
  FormControl,
  Checkbox,
  FormControlLabel,
  Box,
  Grid
} from "@mui/material";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Swal from "sweetalert2";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Slide from "@mui/material/Slide";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const JobApplicationStatusSettings = () => {
  const [statuses, setStatuses] = useState([
    { id: 1, name: "applied", category: "applied", color: "#2b2b2b", position: 1 },
    { id: 2, name: "phone screen", category: "shortlist", color: "#f1e52e", position: 2 },
    { id: 3, name: "interview", category: "interview", color: "#3d8ee8", position: 3 },
    { id: 4, name: "hired", category: "hired", color: "#32ac16", position: 4 },
    { id: 5, name: "rejected", category: "rejected", color: "#ee1127", position: 5 },
  ]);

  const [openDialog, setOpenDialog] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentStatus, setCurrentStatus] = useState({
    id: null,
    name: "",
    category: "",
    color: "#000000",
    position: "",
    applyModelActions: true,
  });

  const handleOpenDialog = () => {
    setCurrentStatus({
      id: null,
      name: "",
      category: "",
      color: "#000000",
      position: "",
      applyModelActions: true,
    });
    setIsEditing(false);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setCurrentStatus({
      id: null,
      name: "",
      category: "",
      color: "",
      position: "",
      applyModelActions: true,
    });
  };

  const handleSaveStatus = () => {
    if (isEditing) {
      setStatuses((prev) =>
        prev.map((status) =>
          status.id === currentStatus.id ? currentStatus : status
        )
      );
      Swal.fire("Success", "Status updated successfully!", "success");
    } else {
      setStatuses((prev) => [
        ...prev,
        { ...currentStatus, id: prev.length + 1 },
      ]);
      Swal.fire("Success", "Status added successfully!", "success");
    }
    handleCloseDialog();
  };

  const handleEditStatus = (status) => {
    setCurrentStatus(status);
    setIsEditing(true);
    setOpenDialog(true);
  };

  const handleDeleteStatus = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover the deleted record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        setStatuses((prev) => prev.filter((status) => status.id !== id));
        Swal.fire("Deleted!", "The status has been deleted.", "success");
      }
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCurrentStatus((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (e) => {
    setCurrentStatus((prev) => ({
      ...prev,
      applyModelActions: e.target.checked,
    }));
  };

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "white",
        color: "black",
        borderRadius: "10px",
      }}
    >
      <Button
        variant="contained"
        onClick={handleOpenDialog}
        sx={{
          marginBottom: "20px",
          backgroundColor: "#1d82f5",
          color: "white",
          padding: "10px",
          "&:hover": {
            backgroundColor: "orange",
          },
        }}
      >
        <Typography
          sx={{
            color: "white",
            display: "flex",
            alignItems: "center",
          }}
        >
          <AddCircleIcon sx={{ marginRight: 1 }} />
          Add Status
        </Typography>
      </Button>

      <TableContainer component={Paper} style={{ backgroundColor: "white" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ color: "black" }}>Name</TableCell>
              <TableCell style={{ color: "black" }}>Category</TableCell>
              <TableCell style={{ color: "black" }}>Label Color</TableCell>
              <TableCell style={{ color: "black" }}>Position</TableCell>
              <TableCell style={{ color: "black" }}>Apply Model Actions</TableCell>
              <TableCell style={{ color: "black" }} align="right">
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {statuses.map((status) => (
              <TableRow key={status.id}>
                <TableCell style={{ color: "black" }}>{status.name}</TableCell>
                <TableCell style={{ color: "black" }}>{status.category}</TableCell>
                <TableCell>
                  <span
                    style={{
                      display: "inline-block",
                      width: "20px",
                      height: "20px",
                      backgroundColor: status.color,
                      borderRadius: "50%",
                      marginRight: "10px",
                      color: "black"
                    }}
                  ></span>
                  <span style={{ color: "black" }}>{status.color}</span>
                </TableCell>
                <TableCell style={{ color: "black" }}>{status.position}</TableCell>
                <TableCell style={{ color: "black" }}>
                  {status.applyModelActions ? "Yes" : "No"}
                </TableCell>
                <TableCell align="right">
                  <Button
                    variant="outlined"
                    style={{ marginRight: "10px" }}
                    onClick={() => handleEditStatus(status)}
                  >
                    <EditNoteIcon /> Edit
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => handleDeleteStatus(status.id)}
                  >
                    <DeleteForeverIcon /> Delete
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog
        fullWidth
        maxWidth="sm"
        open={openDialog}
        onClose={handleCloseDialog}
        TransitionComponent={Transition}
        PaperProps={{
          style: {
            position: "absolute",
            background: "#fff",
            top: "0",
            backgroundColor: "white",
            maxHeight: "95%",
            margin: "auto",
            overflowX: "hidden",
            zIndex: 1200,
          },
        }}
      >
        <Box>
          <AppBar sx={{ position: "relative", bgcolor: "#1d82f5" }}>
            <Toolbar>
              <Typography
                sx={{ ml: 2, flex: 1, fontSize: "18px" }}
                component="div"
              >
                {isEditing ? "Edit Status Column" : "Add Status Column"}
              </Typography>
            </Toolbar>
          </AppBar>
        </Box>
        <Box
          sx={{
            bgcolor: "white",
            boxShadow: 24,
          }}
        >
          <DialogContent>
            <Box sx={{ display: "flex", gap: 2, flexDirection: "row", mb: 2 }}>
              <Box sx={{ flex: 1 }}>
                <label htmlFor="category" style={{ fontSize: "14px", color: "#333" }}>Category</label>
                <FormControl
                  fullWidth
                  variant="outlined"
                  required
                  sx={{
                    mt: 1,
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': { borderColor: '#d9d9d9' },
                      '&:hover fieldset': { borderColor: 'black' },
                      '&.Mui-focused fieldset': { borderColor: 'black' },
                    },
                  }}
                >
                  <Select
                    name="category"
                    id="category"
                    value={currentStatus.category}
                    onChange={handleChange}
                    style={{
                      color: "black",
                      backgroundColor: "white",
                    }}
                    required
                  >
                    <MenuItem value="applied">Applied</MenuItem>
                    <MenuItem value="shortlist">Shortlist</MenuItem>
                    <MenuItem value="interview">Interview</MenuItem>
                    <MenuItem value="hired">Hired</MenuItem>
                    <MenuItem value="rejected">Rejected</MenuItem>
                  </Select>
                </FormControl>
                {currentStatus.category === "" && (
                  <span style={{ color: "red", fontSize: "12px" }}>
                    Category is required
                  </span>
                )}
              </Box>

              <Box sx={{ flex: 1 }}>
                <label htmlFor="name" style={{ fontSize: "14px", color: "#333" }}>Status</label>
                <TextField
                  name="name"
                  id="name"
                  value={currentStatus.name}
                  onChange={handleChange}
                  fullWidth
                  required
                  InputProps={{
                    style: {
                      color: "black",
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="outlined"
                  sx={{
                    mt: 1,
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': { borderColor: '#d9d9d9' },
                      '&:hover fieldset': { borderColor: 'black' },
                      '&.Mui-focused fieldset': { borderColor: 'black' },
                    },
                  }}
                />
                {currentStatus.name === "" && (
                  <span style={{ color: "red", fontSize: "12px" }}>
                    Status is required
                  </span>
                )}
              </Box>
            </Box>

            <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
              <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
                <label htmlFor="color" style={{ fontSize: "14px", color: "#333" }}>Label Color</label>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                  <TextField
                    name="color"
                    id="color"
                    value={currentStatus.color}
                    onChange={handleChange}
                    fullWidth
                    required
                    InputProps={{
                      style: {
                        color: "black",
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: '#d9d9d9' },
                        '&:hover fieldset': { borderColor: 'black' },
                        '&.Mui-focused fieldset': { borderColor: 'black' },
                      },
                    }}
                  />
                  <input
                    type="color"
                    value={currentStatus.color}
                    onChange={(e) =>
                      setCurrentStatus((prev) => ({
                        ...prev,
                        color: e.target.value,
                      }))
                    }
                    style={{
                      width: "40px",
                      height: "40px",
                      border: "none",
                      cursor: "pointer",
                    }}
                  />
                </Box>
                {currentStatus.color === "" && (
                  <span style={{ color: "red", fontSize: "12px" }}>
                    Label color is required
                  </span>
                )}
              </Box>

              <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
                <label htmlFor="position" style={{ fontSize: "14px", color: "#333" }}>Position</label>
                <FormControl
                  fullWidth
                  sx={{
                    mt: 1,
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': { borderColor: '#d9d9d9' },
                      '&:hover fieldset': { borderColor: 'black' },
                      '&.Mui-focused fieldset': { borderColor: 'black' },
                    },
                  }}
                >
                  <Select
                    name="position"
                    id="position"
                    value={currentStatus.position}
                    onChange={handleChange}
                    style={{
                      color: "black",
                      backgroundColor: "white",
                    }}
                  >
                    <MenuItem value="before_hired">Before Hired</MenuItem>
                    <MenuItem value="before_shortlist">Before Shortlist</MenuItem>
                    <MenuItem value="after_applied">After Applied</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Box>

            <Box sx={{ mt: 2 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={currentStatus.applyModelActions}
                    onChange={handleCheckboxChange}
                    style={{ color: "#1d82f5" }}
                  />
                }
                label="Apply model actions"
                style={{ color: "black" }}
              />
            </Box>
          </DialogContent>

          <DialogActions>
            <Grid container sx={{ padding: "10px 0 20px 20px" }}>
              <Grid item xs={11} className="messageFooter">
                <Box
                  className="response"
                  onClick={handleSaveStatus}
                  sx={{
                    display: "inline-block",
                    padding: "8px 16px",
                    backgroundColor: "#1d82f5",
                    color: "white",
                    borderRadius: "4px",
                    cursor: "pointer",
                    '&:hover': {
                      backgroundColor: 'orange',
                    },
                    pointerEvents: currentStatus.category === "" || currentStatus.name === "" || currentStatus.color === "" ? "none" : "auto",
                    opacity: currentStatus.category === "" || currentStatus.name === "" || currentStatus.color === "" ? 0.5 : 1,
                  }}
                >
                  Save
                </Box>

                <Box
                  className="cancel"
                  onClick={handleCloseDialog}
                  sx={{
                    display: "inline-block",
                    padding: "8px 16px",
                    color: "black",
                    borderRadius: "4px",
                    cursor: "pointer",
                    '&:hover': {
                      backgroundColor: 'orange',
                    },
                  }}
                >
                  Cancel
                </Box>
              </Grid>
            </Grid>
          </DialogActions>
        </Box>
      </Dialog>
    </div>
  );
};

export default JobApplicationStatusSettings;
